export default "__VITE_ASSET__CwLRXYqW__"